import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

var Indeterminate = function Indeterminate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 10 4"
  }), /*#__PURE__*/React.createElement("rect", {
    y: "0.5",
    width: "10",
    height: "3",
    rx: "1.5"
  }));
};

Indeterminate.displayName = 'Indeterminate';
export default Indeterminate;